import type {ActionReducerMapBuilder} from "@reduxjs/toolkit";
import type {EventOneClickPromoReduxState} from "@Panels/event-one-click-promotion-panel/event-one-click-promotion-panel.types";
import {refreshOneClickEmailSends} from "@Panels/event-one-click-promotion-panel/event-one-click-promotion-panel-thunk";

export const eventOneClickPromotionPanelExtraReducers = (builder: ActionReducerMapBuilder<EventOneClickPromoReduxState>): void => {
    builder.addCase(refreshOneClickEmailSends.fulfilled, (state, {payload}) => {
        state.emailSends = payload;
    });
}
